import { MinusOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
import { Input } from 'antd';
import { IShare, IResource } from '../../../types';
import EditableResource from './EditableResource';
import { Weight, Share, DeleteShare } from './styled';

interface IProps {
  share: IShare;
  resources: IResource[];
  setShare: (sid: number, share: IShare) => void;
  allowDelete?: boolean;
  onDelete: (sid: number) => void;
}

const PolicyShare: React.FC<IProps> = ({
  share,
  resources = [],
  setShare,
  allowDelete = false,
  onDelete,
}) => {
  const onWeightChange = useCallback(
    (e) => {
      const weightPct = parseFloat(e.target.value);
      // because float math increases precision
      share.weight = Number((weightPct * 100).toFixed(2));
      setShare(share.id, share);
    },
    [setShare, share.id],
  );

  const handleDelete = useCallback(() => {
    onDelete(share.id);
  }, [onDelete]);

  const actualWeight = share.weight / 100;
  return (
    <Share>
      <EditableResource
        key={JSON.stringify(share)}
        share={share}
        resources={resources}
        setShare={setShare}
      />
      <Weight>
        <Input defaultValue={`${actualWeight}`} onChange={onWeightChange} maxLength={5} />
      </Weight>
      {allowDelete && <DeleteShare onClick={handleDelete} icon={<MinusOutlined />} />}
    </Share>
  );
};

export default PolicyShare;
